import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { GetUserLevelsDistributionDto } from '../../../models/analytics/dto/get-user-levels-distribution.dto';

export const GET_USER_LEVELS_DISTRIBUTION_QUERY_KEY = 'getUserLevelsDistribution';

export const useGetUserLevelsDistribution = (organizationId: string) => {
    const apiClient = useApiClient();
    return useQuery({
        queryKey: [GET_USER_LEVELS_DISTRIBUTION_QUERY_KEY, organizationId],
        queryFn: async () => {
            const response = await apiClient.fetchApi<GetUserLevelsDistributionDto, {}>({ method: 'GET', endpoint: `analytics/user-levels-distribution?organizationId=${organizationId}` });
            return response;
        },
        enabled: !!organizationId,
        staleTime: 5 * 60 * 1000,
    });
};
